import { ExportPicker } from '@/components/controls';
import {
  getVehiclePolls,
  shortVehicleHeaders,
  telematicsBoxPollHeaders,
} from '@/utils';

export function DownloadPollsLink({ entry }) {
  async function fetchDataToConvert() {
    const polls = await getVehiclePolls(
      entry.vehicle.telematicsBoxImei,
      entry.startTime,
      entry.endTime,
    );
    const data = polls.map((poll) => ({
      ...poll,
      identificationNumber: entry.vehicle.identificationNumber,
      registrationNumber: entry.vehicle.registrationNumber,
      fleetNumber: entry.vehicle.fleetNumber,
      time: new Date(poll.time),
      vehicleRole: entry.vehicle.role,
      longitude: poll.position ? poll.position.coordinates[0] : 0,
      latitude: poll.position ? poll.position.coordinates[1] : 0,
    }));

    return data;
  }

  return (
    <ExportPicker
      fetchDataToConvert={fetchDataToConvert}
      filename="vehicle-location-visit-polls"
      headers={[...shortVehicleHeaders, ...telematicsBoxPollHeaders]}
    />
  );
}
